import { render, staticRenderFns } from "./btn-builder.vue?vue&type=template&id=4c549cc8&"
import script from "./btn-builder.vue?vue&type=script&lang=js&"
export * from "./btn-builder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports